/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ActivityState {
    /**
     * Browser offline
     */ 
    Inactive = 0,
    /**
     * Browser online
     */ 
    Active = 1,
}
